import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_choose_account_type",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Create Account", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  id: "kt_modal_choose_account_type_closebutton",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_7 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body scroll-y m-5" }
const _hoisted_10 = {
  ref: "createAccountRef",
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "stepper-nav py-5" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "stepper-item current",
    "data-kt-stepper-element": "nav"
  }, [
    /*#__PURE__*/_createVNode("h3", { class: "stepper-title" }, " Account Type ")
  ])
], -1)
const _hoisted_12 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Choose Account Type "),
    /*#__PURE__*/_createVNode("i", {
      class: "fas fa-exclamation-circle ms-2 fs-7",
      "data-bs-toggle": "tooltip",
      title: "Billing is issued based on your selected account type"
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Please select the account type you would like to encode in this slot. ")
], -1)
const _hoisted_15 = { class: "fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_18 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_addovi"
}
const _hoisted_19 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_20 = { class: "d-block fw-bold text-start" }
const _hoisted_21 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_22 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_23 = {
  key: 1,
  class: "col-lg-6"
}
const _hoisted_24 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_regovi"
}
const _hoisted_25 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_26 = { class: "d-block fw-bold text-start" }
const _hoisted_27 = { class: "text-dark fw-bolder d-block fs-4 mb-2" }
const _hoisted_28 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_29 = {
  key: 2,
  class: "col-lg-6"
}
const _hoisted_30 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_addec"
}
const _hoisted_31 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " Personal EC/EDPLAN Account "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "ADDITIONAL EC/EDPLAN UNDER YOUR NAME")
], -1)
const _hoisted_33 = {
  key: 3,
  class: "col-lg-6"
}
const _hoisted_34 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center mb-10",
  for: "kt_create_account_form_account_type_regec"
}
const _hoisted_35 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "d-block fw-bold text-start" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-dark fw-bolder d-block fs-4 mb-2" }, " BUSINESS PARTNER EC/EDPLAN Account "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400 fw-bold fs-6" }, "NEW EC/EDPLAN ACCOUNT FOR YOUR BUSINESS PARTNER")
], -1)
const _hoisted_37 = { class: "d-flex flex-stack pt-15" }
const _hoisted_38 = { class: "me-2" }
const _hoisted_39 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_41 = { class: "indicator-label" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_43 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_el_skeleton, {
            rows: 5,
            animated: ""
          })
        ], 512), [
          [_vShow, _ctx.isLoading]
        ]),
        _withDirectives(_createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("form", {
              class: "mx-auto mw-600px w-100 py-10",
              novalidate: "novalidate",
              id: "kt_create_account_form",
              onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
            }, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      (_ctx.planType === 'ovi' || _ctx.planType === 'ecp')
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            _withDirectives(_createVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "accountType",
                              value: "addovi",
                              checked: "checked",
                              id: "kt_create_account_form_account_type_addovi",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.accountType = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.accountType]
                            ]),
                            _createVNode("label", _hoisted_18, [
                              _createVNode("span", _hoisted_19, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/User.svg" })
                              ]),
                              _createVNode("span", _hoisted_20, [
                                _createVNode("span", _hoisted_21, " Personal " + _toDisplayString(_ctx.hasOVIPackage == true ? 'EC/EDPLAN/' : '') + "OVI Account ", 1),
                                _createVNode("span", _hoisted_22, "ADDITIONAL " + _toDisplayString(_ctx.hasOVIPackage == true ? 'EC/EDPLAN/' : '') + "OVI ACCOUNT UNDER YOUR NAME/PACKAGE WITH SEALPRO", 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.planType === 'ovi' || _ctx.planType === 'ecp')
                        ? (_openBlock(), _createBlock("div", _hoisted_23, [
                            _withDirectives(_createVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "accountType",
                              value: "regovi",
                              id: "kt_create_account_form_account_type_regovi",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.accountType = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.accountType]
                            ]),
                            _createVNode("label", _hoisted_24, [
                              _createVNode("span", _hoisted_25, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/User.svg" })
                              ]),
                              _createVNode("span", _hoisted_26, [
                                _createVNode("span", _hoisted_27, " BUSINESS PARTNER " + _toDisplayString(_ctx.hasOVIPackage == true ? 'EC/EDPLAN/' : '') + "OVI Account ", 1),
                                _createVNode("span", _hoisted_28, "NEW " + _toDisplayString(_ctx.hasOVIPackage == true ? 'EC/EDPLAN/' : '') + "OVI ACCOUNT FOR YOUR BUSINESS PARTNER/PACKAGE WITH SEALPRO", 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasOVIPackage == false)
                        ? (_openBlock(), _createBlock("div", _hoisted_29, [
                            _withDirectives(_createVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "accountType",
                              value: "addec",
                              id: "kt_create_account_form_account_type_addec",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.accountType = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.accountType]
                            ]),
                            _createVNode("label", _hoisted_30, [
                              _createVNode("span", _hoisted_31, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/User.svg" })
                              ]),
                              _hoisted_32
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.hasOVIPackage == false)
                        ? (_openBlock(), _createBlock("div", _hoisted_33, [
                            _withDirectives(_createVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "accountType",
                              value: "regec",
                              id: "kt_create_account_form_account_type_regec",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.accountType = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.formData.accountType]
                            ]),
                            _createVNode("label", _hoisted_34, [
                              _createVNode("span", _hoisted_35, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Interface/User.svg" })
                              ]),
                              _hoisted_36
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-light-primary me-3",
                    "data-kt-stepper-action": "previous",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.previousStep()))
                  }, [
                    _createVNode("span", _hoisted_39, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                    ]),
                    _hoisted_40
                  ])
                ]),
                _createVNode("div", null, [
                  (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "submit",
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit()))
                      }, [
                        _createVNode("span", _hoisted_41, [
                          _hoisted_42,
                          _createVNode("span", _hoisted_43, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Right-2.svg" })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 32)
          ], 512)
        ], 512), [
          [_vShow, _ctx.isLoading == false]
        ])
      ])
    ])
  ]))
}